import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from 'src/app/services/config.service';

@Injectable({
  providedIn: 'root'
})
export class OrdersService {
  endpoint:any;
  constructor(private http: HttpClient, private configService: ConfigService) {
   this.endpoint = this.configService.endpoints;
   }

  getToxLabOrders(filterModel, customFilter) {
    return `${this.endpoint.APIEndpoint}/ToxLabOrders/list/?${filterModel.PageSize}&${filterModel.RunCount}&${filterModel.StartPageNo}&${filterModel.SortExpression}&${customFilter}`;
  }

  getException(filterModel, customFilter) {
    return `${this.endpoint.APIEndpoint}/ToxLabOrders/list/exceptions?${filterModel.PageSize}&${filterModel.RunCount}&${filterModel.StartPageNo}&${filterModel.SortExpression}&${customFilter}`;
  }

  getLabOrderPdf(orderId) {
    return this.http.post(`${this.endpoint.APIEndpoint}/ToxLabOrders/RequisitionReport/base64/${orderId}`, null, { headers: { 'Content-Type': 'application/json' }, responseType: 'text' });
  }

  getToxLabOrdersLogs(id, filterModel, customFilter) {
    return `${this.endpoint.APIEndpoint}/ToxLabOrders/logs/list/${id}?${filterModel.PageSize}&${filterModel.RunCount}&${filterModel.StartPageNo}&${filterModel.SortExpression}&${customFilter}`;
  }

  exportToxLabOrdersToExcel(customFilter) {
    return this.http.post(`${this.endpoint.APIEndpoint}/ToxLabOrders/laborder/export/file?${customFilter}`, null, { responseType: 'text' });
  }

  exportToxLabOrdersExceptionsToExcel(customFilter) {
    return this.http.post(`${this.endpoint.APIEndpoint}/ToxLabOrders/laborder/exceptions/export/file?${customFilter}`, null, { responseType: 'text' });
  }

  getOrderinfo(id) {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/ToxLabOrders/orderinfo/${id}`);
  }

  getPatientinfo(id) {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/Patient/${id}`);
  }

  getInsuranceDetails(id) {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/InsuranceDetails/patientByOrderId/${id}`);
  }

  getDocumentList(id, filterModel, customFilter) {
    return `${this.endpoint.APIEndpoint}/Document/list/by/orderid/${id}?${filterModel.PageSize}&${filterModel.RunCount}&${filterModel.StartPageNo}&${filterModel.SortExpression}&${customFilter}`;
  }

  previewDocument(id) {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/Document/getDocument/${id}`);
  }

  requisitionReport(id) {
    return this.http.post(`${this.endpoint.APIEndpoint}/ToxLabOrders/RequisitionReport/base64/${id}`, null, { headers: { 'Content-Type': 'application/json' }, responseType: 'text' });
  }

  cancellationReasonList() {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/CancellationReason/list`);
  }

  convertToMolecularCase(orderId) {
    return this.http.post<any>(`${this.endpoint.APIEndpoint}/ToxLabOrders/convert/to/molecular-case/${orderId}`, null);
  }

  acceptOrder(orderId, rejectOrder) {
    return this.http.post<any>(`${this.endpoint.APIEndpoint}/CaseOrder/convert/order/${orderId}/${rejectOrder}`, null);
  }

  rejectOrder(data) {
    return this.http.post<any>(`${this.endpoint.APIEndpoint}/ToxLabOrders/RejectOrder`, data);
  }

  getPracticeLocation(labId) {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/labClient/list/labclients/${labId}`);
  }

  getOrderingPhysician(locationid, labclientid) {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/labclient/physicians/by/location/${locationid}/${labclientid}`);
  }

  getLocation(labClientId) {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/LabLocation/list/${labClientId}`);
  }
  getLocationDDO(){
    return this.http.get(`${this.endpoint.APIEndpoint}/LabLocation/ddo`);
  }

  searchPatient(patientId, searchText, labClientId) {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/Patient/search?patientId=${patientId}&searchText=${searchText}&labClientId=${labClientId}`);
  }

  searchIcd(searchText) {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/Icd10codes/search/${searchText}`);
  }

  getMacros() {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/Macro/list/macros`);
  }

  getDrugsListForPgx() {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/PgxDrugsList/list`);
  }

  getDrugsList() {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/Drug/drugList`);
  }

  getOrderDetailsById(id) {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/ToxLabOrders/orderinfo/${id}`);
  }

  getOrderReasonDDO() {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/OrderReason/list`);
  }

  getInsurance(patientId) {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/insurancedetails/patientByPatientId/${patientId}`);
  }
  getInsuranceDetail(id) {
    return this.http.get(`${this.endpoint.APIEndpoint}/InsuranceDetails/${id}`);
  }

  deleteInsurance(id) {
    return this.http.delete(`${this.endpoint.APIEndpoint}/InsuranceDetails/${id}`);
  }

  getSelectedSpecialityType(id) {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/LabClient/${id}`);
  }

  getProfilesBasedonClientId(labClientId) {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/Profile/profilelist/${labClientId}`);
  }

  getTestCodeList() {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/TestCode/TestCodesList`);
  }

  getOrderResults(data) {
    return this.http.post<any>(`${this.endpoint.APIEndpoint}/ToxLabOrders/CompoundsByMedications`, data);
  }
  printLabel(orderId, numberOfLabels){
    return this.http.get(`${this.endpoint.APIEndpoint}/ToxLabOrders/print/${orderId}/${numberOfLabels}`);
  }

  getCompoundsBasedOnSpecimen(specimenTypeId) {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/Compound/getlistbySpecimenType/${specimenTypeId}`);
  }

  getTestCodeCompoundByTestCodeId(testCodeId) {
    return this.http.post<any>(`${this.endpoint.APIEndpoint}/testcodeCompound/list/${testCodeId}`, null);
  }

  // api call to get molecular profiles list
  getOrderCaseTestProfile(specimenTypeId) {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/testprofile/SpecimenType/${specimenTypeId}`);
  }

  getCaseTypeProfilesForOrderByLabClient(labClientId) {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/ChemicalTestProfiles/ddo/labClient/${labClientId}`);
  }

  createMolecularNewOrder(data) {
    return this.http.post<any>(`${this.endpoint.APIEndpoint}/ToxLabOrders/CreateMolecularOrderAndCase`, data);
  }

  createNewOrder(data) {
    return this.http.post<any>(`${this.endpoint.APIEndpoint}/ToxLabOrders/CreateOrderAndCase`, data);
  }

  createNewOrderClient(data) {
    return this.http.post<any>(`${this.endpoint.APIEndpoint}/ToxLabOrders`, data);
  }

  convertToCaseInBatch(data) {
    return this.http.post<any>(`${this.endpoint.APIEndpoint}/ToxLabOrders/batch/convert/to/case`, data);
  }

  createMultipleLabOrder(data) {
    return this.http.post(`${this.endpoint.APIEndpoint}/ToxLabOrders/createmultipleorders`, data);
  }

  getOrderLogs(id) {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/OrderLogs/list/${id}`);
  }

  addOrderNote(data) {
    return this.http.post<any>(`${this.endpoint.APIEndpoint}/OrderLogs`, data);
  }

  createCodes(data) {
    return this.http.post<any>(`${this.endpoint.APIEndpoint}/Icd10codes`, data);
  }

  getReasons() {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/CancellationReason/list`);
  }

  getLabClientCollector(labclientId) {
    return this.http.get(`${this.endpoint.APIEndpoint}/LabClientCollectors/list/${labclientId}`);
  }

  deleteLabOrder(id) {
    return this.http.delete<any>(`${this.endpoint.APIEndpoint}/ToxLabOrders/${id}`);
  }

  orderNotified(orderid, flag) {
    return this.http.post<any>(`${this.endpoint.APIEndpoint}/ToxLabOrders/notified/${flag}/${orderid}`, null);
  }

  createMultipleOrders(data) {
    return this.http.post<any>(`${this.endpoint.APIEndpoint}/ToxLabOrders/createmultipleorders`, data);
  }

  getAntibodyTestReport(orderId) {
    return this.http.post(`${this.endpoint.APIEndpoint}/ToxLabOrders/AntiBodyTestReport/${orderId}`, null, { responseType: 'text' });
  }

  getCaseReportBase64(caseId) {
    return this.http.post(`${this.endpoint.APIEndpoint}/CaseOrder/casereport/base64/${caseId}`, null, { responseType: 'text' });
  }

  getPdfReportForMolecular(caseId) {
    return this.http.get(`${this.endpoint.APIEndpoint}/casetestreport/CaseReport/${caseId}`, { responseType: 'text' });
  }

  revertOrder(orderId) {
    return this.http.post<any>(`${this.endpoint.APIEndpoint}/ToxLabOrders/revert/status/${orderId}`, null);
  }

  getCovidOrdersDocument(orderId) {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/document/AntibodyTestImage/${orderId}`);
  }

  sendCovidOrders(orderId, data) {
    return this.http.post<any>(`${this.endpoint.APIEndpoint}/ToxLabOrders/Update/AntibodyResult/${orderId}`, data);
  }

  getPreviousCaseICDCodes(patientId, caseType) {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/CaseOrder/GetPreviousCaseICDCodes/${patientId}/${caseType}`);
  }

  getClinicalSetting() {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/ClinicalSetting/list/`);
  }

  sendRiskData(riskDataId) {
    return this.http.post<any>(`${this.endpoint.APIEndpoint}/toxOrderRiskData/orderdata/${riskDataId}`, null);
  }

  saveAnalyzeRisk(data) {
    return this.http.post<any>(`${this.endpoint.APIEndpoint}/RiskAnalysisData/risktype/by/questions/answers`, data);
  }

  getProfilesByAnswer(labClientId, answerId) {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/Profile/profilelist/${labClientId}/${answerId}`);
  }
  getSymptom(typeId){
    return this.http.get(`${this.endpoint.APIEndpoint}/Macro/ddo/${typeId}`);
  }

  verifyEligibility(patientId, insuranceId, physicianId) {
    return this.http.get(`${this.endpoint.APIEndpoint}/patient/eligibilitycheck/${patientId}/${insuranceId}/${physicianId}`);
  }
  getPreviousPrescribedDrugByMultipleParam(patientId,labclientId,labLocationid){
    return this.http.get(`${this.endpoint.APIEndpoint}/CaseOrderDrug/list/medications/${patientId}/${labclientId}/${labLocationid}`);
  }

  getProfilesBySpecimenType(specimenTypeId) {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/Profile/profileList/SpecimenType/${specimenTypeId}`);
  }

  getAntibioticsList() {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/Antibiotics/antibioticsDDO`);
  }

}
